import React from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { LocaleProvider } from 'antd';
import { IntlProvider } from 'react-intl';
import Amplify, { Auth } from 'aws-amplify';
import AWSAppSyncClient, { AUTH_TYPE } from 'aws-appsync';
import { ApolloProvider } from 'react-apollo';
import { history, store } from './redux/store';
import PublicRoutes from './router';
import themes from './config/themes';
import AppLocale from './languageProvider';
import config, { getCurrentLanguage } from './containers/LanguageSwitcher/config';
import { themeConfig } from './config';
import DashAppHolder from './dashAppStyle';
import Boot from './redux/boot';
import awsmobiledev from './aws-exports-dev';
import awsmobileprod from './aws-exports-prod';
import graphql_endpoints from './aws-appsync-url';

const env = process.env.REACT_APP_NODE_ENV;
const aws = env === 'prod' ? awsmobileprod : awsmobiledev;

Amplify.configure(env === 'prod' ? awsmobileprod : awsmobiledev);
Amplify.configure({
  // DBT Daily
  API: {
    graphql_headers: async () => {
      let token = await Auth.currentSession();
      token = token.idToken.jwtToken;
      return {
        Authorization: token,
      };
    },
    graphql_endpoint: graphql_endpoints.DBT,
  },
  // Swasth Common
  API1: {
    graphql_headers: async () => {
      let token = await Auth.currentSession();
      token = token.idToken.jwtToken;
      return {
        Authorization: token,
      };
    },
    graphql_endpoint: graphql_endpoints.SWASTH,
  },
  // BT Portal
  API2: {
    graphql_headers: async () => {
      let token = await Auth.currentSession();
      token = token.idToken.jwtToken;
      return {
        Authorization: token,
      };
    },
    graphql_endpoint: graphql_endpoints.BTPORTAL,
  },
});

// window.LOG_LEVEL = 'DEBUG';
export const btPortalClient = new AWSAppSyncClient({
  url: graphql_endpoints.BTPORTAL,
  region: aws.aws_cognito_region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => (await Auth.currentSession()).getIdToken().getJwtToken(),
  },
  // disableOffline: true,
  offlineConfig: {
    keyPrefix: 'btportal-app-sync',
    callback: (err, succ) => {
      if (err) {
        const { mutation } = err;
        console.warn(`ERROR for ${mutation}`, err);
      } else {
        const { mutation } = succ;
        console.info(`SUCCESS for ${mutation}`, succ);
      }
    },
  },
});

export const swasthCommonsClient = new AWSAppSyncClient({
  url: graphql_endpoints.SWASTH,
  region: aws.aws_cognito_region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => (await Auth.currentSession()).getIdToken().getJwtToken(),
  },
  offlineConfig: {
    keyPrefix: 'swasthCommon',
    callback: (err, succ) => {
      if (err) {
        const { mutation } = err;
        console.warn(`ERROR for ${mutation}`, err);
      }
    },
  },
});

const currentAppLocale = AppLocale[getCurrentLanguage(config.defaultLanguage || 'english').locale];

const DashApp = () => (
  <ApolloProvider client={swasthCommonsClient}>
    <LocaleProvider locale={currentAppLocale.antd}>
      <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
        <ThemeProvider theme={themes[themeConfig.theme]}>
          <DashAppHolder>
            <Provider store={store}>
              <PublicRoutes history={history} />
            </Provider>
          </DashAppHolder>
        </ThemeProvider>
      </IntlProvider>
    </LocaleProvider>
  </ApolloProvider>
);
Boot()
  .then(() => DashApp())
  .catch(error => console.error(error));

export default DashApp;
export { AppLocale };
